import React from "react";
import Modal from "react-responsive-modal";
import { ActionBtn } from "../../../../../../Utils/Buttons/ActionBtn";

const calculateIcon = require("assets/img/icons/calculate-icon.png");
const emptyIcon = require("assets/img/icons/empty-icon.png");
const repeatIcon = require("assets/img/icons/repeat-icon.png");
const undoIcon = require("assets/img/icons/undo.png");

// destinoEnvio: planta en los acopios, producción en la planta
const getAccionesAlmacen = (destinoEnvio) => [
    {
        titulo: "Procesar sobrante",
        icono: calculateIcon,
        color: "#035B2F",
        descripcion: `Abre la gestión del almacén, donde se seleccionan las recepciones no enviadas a ${destinoEnvio} o se solicita un análisis DRC del sobrante. El inventario final se calcula a partir de esa información.`,
    },
    {
        titulo: "Utilizar mismo inventario",
        icono: repeatIcon,
        color: "#999999",
        descripcion: `Indica que el almacén no envió materia prima a ${destinoEnvio}, por lo que su inventario final es el inventario inicial más los ingresos del periodo. El almacén pasa al estado Sin cambios.`,
    },
    {
        titulo: "Marcar inventario final vacío",
        icono: emptyIcon,
        color: "#FFC107",
        descripcion: `Indica que toda la materia prima del almacén fue enviada a ${destinoEnvio}, por lo que su inventario final es 0 kg en laboratorio y en liquidación. El almacén pasa al estado En cero.`,
    },
    {
        titulo: "Marcar como pendiente",
        icono: undoIcon,
        color: "#0b4f9e",
        descripcion:
            "Disponible en los almacenes en estado Sin cambios o En cero. Devuelve el almacén al estado Pendiente para procesarlo nuevamente.",
    },
];

export const AyudaAccionesModal = ({
    open,
    onClose,
    textConfig,
    incluyeReproceso,
}) => {
    const { destinoEnvio } = textConfig;

    return (
        <Modal
            open={open}
            onClose={onClose}
            focusTrapped={false}
            styles={{
                modal: {
                    maxWidth: "600px",
                    width: "90%",
                },
            }}
        >
            <h2 className="text-center">Acciones por almacén</h2>

            <ul className="almacenes-inventario__ayuda-lista">
                {getAccionesAlmacen(destinoEnvio).map((accion) => (
                    <li
                        key={accion.titulo}
                        className="almacenes-inventario__ayuda-item"
                    >
                        <span className="almacenes-inventario__ayuda-icono">
                            <ActionBtn
                                imgSource={accion.icono}
                                title={accion.titulo}
                                btnColor={accion.color}
                            />
                        </span>
                        <div>
                            <strong>{accion.titulo}</strong>
                            <p className="m-0">{accion.descripcion}</p>
                        </div>
                    </li>
                ))}
            </ul>

            <ul className="almacenes-inventario__ayuda-notas">
                <li>
                    Utilizar mismo inventario y Marcar inventario final vacío
                    descartan las recepciones registradas como no enviadas a{" "}
                    {destinoEnvio} y el análisis DRC del sobrante. Si el
                    almacén tiene esa información, se solicita confirmación
                    antes de descartarla.
                </li>
                {incluyeReproceso && (
                    <li>
                        El almacén de reproceso no tiene acciones: su inventario
                        final se calcula automáticamente con lo enviado por
                        bodega de producto terminado menos lo consumido en
                        producción.
                    </li>
                )}
            </ul>

            <div className="d-flex justify-content-center mt-4 mb-2">
                <button className="btn btn-outline-dark" onClick={onClose}>
                    Cerrar
                </button>
            </div>
        </Modal>
    );
};
